var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('a',{on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.is_hidden ? "Show" : "Hide"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }